var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadExcelCloudIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1593 8.65398L14.4436 10.168L15.98 10.2797C17.0399 10.3568 18 11.3008 18 12.625C18 12.9501 17.9389 13.2698 17.8224 13.5653C17.7059 13.8606 17.5375 14.1228 17.3313 14.3393C17.1254 14.5555 16.8862 14.7216 16.6302 14.8329C16.3744 14.9442 16.1039 15 15.8333 15H5C4.23671 15 3.48372 14.6825 2.91274 14.083C2.33861 13.4801 2 12.6426 2 11.75C2 9.99555 3.2518 8.6821 4.68021 8.52265L5.76499 8.40156L6.25002 7.42373C6.98523 5.94156 8.41924 5 10 5C11.9855 5 13.7539 6.49435 14.1593 8.65398ZM16.125 8.28499C15.5583 5.26625 13.0333 3 10 3C7.59167 3 5.5 4.435 4.45834 6.535C1.95 6.81499 0 9.04624 0 11.75C0 13.1424 0.526784 14.4777 1.46447 15.4623C2.40215 16.4469 3.67392 17 5 17H7V15H13V17H15.8333C16.3805 17 16.9223 16.8868 17.4278 16.667C17.9334 16.4471 18.3927 16.1248 18.7796 15.7186C19.1665 15.3123 19.4734 14.83 19.6828 14.2992C19.8922 13.7684 20 13.1995 20 12.625C20 10.315 18.2917 8.44249 16.125 8.28499Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17L10 10.5M10 10.5L13 13.4233M10 10.5L7 13.4233",
    stroke: "#2A2A2A",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadExcelCloudIcon);
export default __webpack_public_path__ + "static/media/upload_excel_cloud_icon.5e6b40bb.svg";
export { ForwardRef as ReactComponent };